import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { Store } from '@ngrx/store';
import { Client } from '@pixacare/domain';
import { first, map, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { selectClient } from '../shared/store/clients/clients.selectors';
import { selectClientCode } from '../shared/store/router/router.selectors';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly store = inject(Store);

  openPixacareSupportForm(): void {
    this.store
      .select(selectClientCode)
      .pipe(
        switchMap((clientCode: string) => this.store.select(selectClient(clientCode))),
        first(),
        map((client: Client) => {
          const hubspotFormUrl = environment.hubspot.formUrl;
          const queryParams = {
            email: this.authenticationService.user.mailAddress,
            company: client && client.code !== environment.commonClientCode ? client.fullName : '',
          };
          const url = `${hubspotFormUrl}?${new URLSearchParams(queryParams)}`;
          window.open(url, '_blank');
        }),
      )
      .subscribe();
  }
}
